import React, { FC } from 'react';
import AddToCartButton from 'components/SalesArea/pages/ProductList/AddToCartButton';
import {
  useCheckoutLineItemsAddMutation,
  ProductVariant,
} from 'graphql/shopify-store-front-api/queries/types.d';

type Props = {
  /**
   * カートに追加する商品のvariant情報
   */
  variant: ProductVariant;
};

/**
 * 商品追加ボタンのロジック部
 */
const EnhancedAddToCartButton: FC<Props> = ({ variant }) => {
  const [
    checkoutLineItemsAddMutation,
    { loading: checkoutLineItemsAddLoading },
  ] = useCheckoutLineItemsAddMutation({
    variables: {
      checkoutId: localStorage.getItem('checkoutId') ?? '',
      lineItems: [{ variantId: variant.id, quantity: 1 }],
    },
  });

  return (
    <AddToCartButton
      onClick={checkoutLineItemsAddMutation}
      isLoading={checkoutLineItemsAddLoading}
      isAvailableForSale={variant.availableForSale}
    />
  );
};

export default EnhancedAddToCartButton;
